import React from 'react';
import NavigationBar from '../NavigationBar';
import WhatsAppButton from '../utilities/WhatsAppButton';
import NotFound from '../utilities/NotFound';

export default function NotFoundPage() {
  return (
    <>
      <NavigationBar />
      <NotFound isDetail={false} />
      <WhatsAppButton />
    </>
  );
}
